<template>
  <v-dialog
    max-width="600"
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xs"
    >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        class="info"
      >
        <v-icon small left>mdi-account-multiple-plus</v-icon>
        {{ $t("importAffiliates") }}
      </v-btn>
    </template>

    <v-card>
      <v-toolbar dense>
        <span>
          {{ $t("massImportAffiliates") }}
        </span>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <div class="pa-6">
        <ImportCSVFile parent="massImportUsers" />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import ImportCSVFile from "@/components/common/importCSVFile/index.vue";
export default {
  name: "affiliates-mass-import",
  components: {
    ImportCSVFile,
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    closeDialog() {
      this.dialog = false;
    },
  }
}
</script>